import WarningIcon from '@material-ui/icons/ErrorOutline';
import WarningSignIcon from '@material-ui/icons/Warning';
import {
  Icon
} from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field } from 'redux-form';
import { BLUE } from '../../../_config/consts';
import Tag from '../../Tag.jsx';
import TagsSelectorField from '../Fields/TagsSelectorField.jsx';

const ItemRow = ({ item, onSelect, isEaven, hasError, hasWarning, isSelected }) => {
  let backgroundColor = !isEaven ? '#FAFAFA' : 'white';
  backgroundColor = hasError ? '#ff7f7f' : backgroundColor;
  backgroundColor = hasWarning ? 'orange' : backgroundColor;
  return (
    <div
      onClick={onSelect || null}
      className="card-noHover tag-element-selected"
      style={{ display: 'flex', zIndex: 0, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: 5, marginBottom: 0, marginTop: 0, cursor: onSelect ? 'pointer' : 'normal', backgroundColor: isSelected ? '#00800036' : backgroundColor }}
    >
      <div onClick={onSelect} style={{ display: 'flex', alignItems: 'center' }}>
        {onSelect &&
        <div>
          {isSelected ?
            <Icon
              glyph="icon-fontello-ok-circled"
              style={{ fontSize: 14, marginRight: 15, color: '#00987C' }}
            />
          :
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 5.5 }}>
              <div style={{ marginBottom: 2, width: 13, height: 13, borderRadius: 6.5, borderStyle: 'solid', borderWidth: 2, borderColor: 'gray' }} />
            </div>
            }
          </div>
        }
        <h5 style={{ margin: 0, color: '#3f3f3f', width: 'max-content' }}>{item.name || `${item.firstname} ${item.lastname}`}{item.email ? <h6 style={{ margin: 0, marginTop: 2, color: '#3f3f3f' }}>{item.email}</h6> : null}</h5>
      </div>
    </div>
  );
};

@connect()
class ExtensionGroupsSelectorField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showList: true,
      searchText: '',
      filteredGroups: props.extensionGroups || []
    };
  }

  componentDidMount() {
    this.updateFilteredGroups();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.extensionGroups, this.props.extensionGroups)) {
      this.updateFilteredGroups();
    }
  }

  updateFilteredGroups() {
    const { extensionGroups } = this.props;
    const { searchText } = this.state;
    
    this.filterGroups(searchText, extensionGroups);
  }

  toggleListVisibility = () => {
    this.setState(prevState => ({ showList: !prevState.showList }));
  }

  handleGroupSelection = (group) => {
    if (!group) return;
    
    const { onSelectGroup, formName, selectedGroupsFieldName, dispatch } = this.props;
    const selectedGroups = this.getSelectedGroups();
    
    if (Array.isArray(group)) {
      if (formName && selectedGroupsFieldName) {
        const newGroupIds = group.map(g => g.id);
        dispatch(change(formName, selectedGroupsFieldName, newGroupIds));
      }
      
      if (onSelectGroup) {
        onSelectGroup(group);
      }
      return;
    }
    
    let newSelectedGroups;
    
    const isAlreadySelected = selectedGroups.some(g => g.id === group.id);
    
    if (isAlreadySelected) {
      newSelectedGroups = selectedGroups.filter(g => g.id !== group.id);
    } else {
      newSelectedGroups = [...selectedGroups, group];
    }
    
    if (formName && selectedGroupsFieldName) {
      const newGroupIds = newSelectedGroups.map(g => g.id);
      dispatch(change(formName, selectedGroupsFieldName, newGroupIds));
    }
    
    if (onSelectGroup) {
      onSelectGroup(newSelectedGroups);
    }
  }

  filterGroups = (searchText, groups = this.props.extensionGroups) => {
    const filteredGroups = searchText ? 
      groups.filter(group => 
        group.name.toLowerCase().includes(searchText.toLowerCase())
      ) : 
      groups;

    this.setState({
      searchText,
      filteredGroups
    });
  }

  handleInputChange = (value) => {
    const { onInputChange } = this.props;
    this.filterGroups(value);
    if (onInputChange) {
      onInputChange(value);
    }
  }

  getSelectedGroups = () => {
    const { extensionGroups, selectedGroups, initialValues } = this.props;
    
    if (initialValues && initialValues.length > 0) {
      return initialValues;
    }
    
    if (selectedGroups && selectedGroups.data && selectedGroups.data.length > 0) {
      return selectedGroups.data;
    }
    
    const selectedGroupIds = this.getSelectedGroupIds();
    
    if (selectedGroupIds.length === 0 || !extensionGroups) {
      return [];
    }
    
    return extensionGroups.filter(group => selectedGroupIds.includes(group.id));
  }

  getSelectedGroupIds = () => {
    const { form, selectedGroupsFieldName } = this.props;
    
    if (form && form.values && form.values[selectedGroupsFieldName]) {
      return form.values[selectedGroupsFieldName];
    }
    
    return [];
  }

  getExtensionsForSelectedGroups = () => {
    const { allExtensions } = this.props;
    const selectedGroups = this.getSelectedGroups();
    
    if (!allExtensions || !Array.isArray(allExtensions) || selectedGroups.length === 0) {
      return [];
    }
    
    const selectedGroupIds = selectedGroups.map(group => group.id);
    
    return allExtensions.filter(extension => {
      return extension && (
          (extension.groupId && selectedGroupIds.includes(extension.groupId)) || 
          (extension.group && extension.group.id && selectedGroupIds.includes(extension.group.id))
        );
    });
  }

  render() {
    const { name, placeholder, title, disabled } = this.props;
    const { showList, filteredGroups } = this.state;
    
    const selectedGroups = this.getSelectedGroups();
    const extensionsInSelectedGroups = this.getExtensionsForSelectedGroups();
    
    const hasSelectedGroups = selectedGroups.length > 0;
    
    return (
      <div>
        <div>
          <Entity
            name={name}
            multi={true}
            componentClass={Field}
            componentAttribute="placeholder"
            entity={placeholder || 'insertExtensionGroups'}
            title={title || <Entity entity="extensionGroups" />}
            tags={filteredGroups}
            isDisabled={disabled}
            component={TagsSelectorField}
            mandatory={true}
            onInputChange={this.handleInputChange}
            onHandleChange={this.handleGroupSelection}
            valueKey="id"
            labelKey="name"
          />
          
          {hasSelectedGroups && (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'inline-flex', flexDirection: 'row', alignItems: 'center' }}>
                <h5 style={{ fontSize: 15 }}><Entity entity="extensionsInSelectedGroups" /></h5>
                <h5 style={{ marginLeft: 5, marginTop: 14 }}>{`(${extensionsInSelectedGroups.length})`}</h5>
              </div>
              <div onClick={this.toggleListVisibility} style={{ cursor: 'pointer', marginLeft: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h5 className="link-label">
                  <Entity key={showList ? 'hide' : 'show'} entity={showList ? 'hide' : 'show'} />
                </h5>
                <Icon
                  style={{ marginLeft: 5, color: '#90CAF9', fontSize: 15 }}
                  className="edit-icon"
                  glyph={showList ? 'icon-fontello-eye-off' : 'icon-fontello-eye-1'}
                />
              </div>
            </div>
          )}
        </div>
        
        <div>
          {hasSelectedGroups && showList && (
            <div style={{ padding: 5, backgroundColor: '#f1f1f1', borderRadius: 10 }}>
              <div style={{ maxHeight: 200, overflowY: 'scroll' }}>
                <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                  {extensionsInSelectedGroups.length > 0 ? (
                    extensionsInSelectedGroups.map((extension, index) => (
                      <ItemRow
                        key={extension.id}
                        item={extension}
                        isEaven={index % 2 === 0}
                      />
                    ))
                  ) : (
                    <div style={{ padding: 10, textAlign: 'center' }}>
                      <h5 style={{ color: '#3f3f3f' }}><Entity entity="noExtensionsInSelectedGroups" /></h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ExtensionGroupsSelectorField; 